export const GuidanceBox = ({title, contents, className, ...props}) => {
    return (
            <div className={`bg-white rounded-r-xl p-4 border-l-4 border-l-blue-500 ${className}`} {...props}>
                <div className="font-bold mb-2">{title}</div>
                <div className="text-sm">
                    {contents}
                </div>
        </div>
    );
}